import { connect } from 'react-redux'

import { setUserVideoPlayerStatus } from '../../../../common/actions/user/preference'
import SearchResultHeader from './searchResultHeader'

const mapStateToProps = (state) => {
  const {
    common: {
      currentSite
    },
    user: {
      preferences
    }
  } = state

  return {
    currentSite,
    preferences
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setUserVideoPlayerStatus: type => dispatch(setUserVideoPlayerStatus(type))
  }
}

const SearchResultHeaderContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResultHeader)

export default SearchResultHeaderContainer



// WEBPACK FOOTER //
// ./client/pages/search/result/searchResultHeaderContainer.js